module.exports = __webpack_public_path__ + "static/img_2358-3b112a7345c5ffa5d3df0ba1146d9d7b.webp";